import { gql } from "@apollo/client";

export const AddDeviceType = gql`
  mutation AddDeviceType(
    $token: String!
    $deviceType: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
  ) {
    AddDeviceType(
      token: $token
      deviceType: $deviceType
      customer_id: $customer_id
      user_details: $user_details
    )
  }
`;

export const UpdateDeviceType = gql`
  mutation UpdateDeviceType(
    $token: String!
    $deviceTypeID: ID!
    $user_details: SubscribedUser!
    $deviceType: String!
  ) {
    UpdateDeviceType(
      token: $token
      deviceTypeID: $deviceTypeID
      user_details: $user_details
      deviceType: $deviceType
    )
  }
`;

export const DeleteDeviceType = gql`
  mutation DeleteDeviceType(
    $token: String!
    $deviceTypeID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteDeviceType(
      token: $token
      deviceTypeID: $deviceTypeID
      user_details: $user_details
    )
  }
`;
